import React, { useState, useRef, useEffect, useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import OtpInput from "react-otp-input";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { useForm } from "react-hook-form";
import appConfig from "../config/app.config";
import {
  getAuth,
  resendOtp,
  resetVerifyOtp,
  resetUserSignup,
  updateProfile,
  userSignup,
  validateEmail,
  verifyOtp,
  setUserType,
  registerPassKey,
} from "../redux/slices/authSlice";
import { getRecaptcha } from "../redux/slices/recaptchaSlice";
import {
  sendOtpMerge,
  mergeUsersLogout,
} from "../redux/slices/accountMergeSlice";
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
  DotGroup,
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import {
  CompleteRegistration,
  getUtmCampaign,
  getUtmMedium,
  getUtmSource,
  HQUserSignup,
  Add_To_Wishlist,
  Web_Signup_completed,
  Web_Signup_landed,
  postMparticleEvent,
} from "../libs/events";
import AccountFooter from "../components/AccountFooter";
import { removeAllLocalStorageData, removeUser } from "../libs/user.js";
import $ from "jquery";
import { getUser, getUserToken } from "../libs/user";
import { inputFormat, phoneValidation } from "../utils/validation";
import { REMITTANCE_SIGNUP } from "../config/constants";
import CustomPopupBox from "./CustomPopupBox";
import emailLogo from "../assets/img/emailLogo.svg";
import phoneLogo from "../assets/img/phoneLogo.svg";
import passkey from "../assets/img/passkey.svg";
import { NUMBER } from "../libs/utils";
import LoadingSpinner from "../components/Loader";
import { REMITTANCE_NB_HOME_PATH } from "../constants";
import { isEmpty } from "lodash";
import { fetchUserData } from "../libs/utils";
// import { SettingsRemoteOutlined } from "@material-ui/icons";
import AppSkeleton from "../components/Skeletons/AppSkeleton";

function Signup() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const screenType =
    searchParams.get("source") === REMITTANCE_SIGNUP
      ? REMITTANCE_SIGNUP
      : "web";
  const utm_source = searchParams.get("utm_source");

  const isRemittanceSignUp = screenType === REMITTANCE_SIGNUP;

  const [passVisisble, setPassVisible] = useState(null);
  const [mount, setMount] = useState(false);
  const [emailReadOnly, setEmailReadOnly] = useState(false);
  const interval0 = useRef();
  const [isSubmitSignup, setSubmitSignup] = useState(false);
  const [screentype, setScreenType] = useState(1);
  const [counter, setCounter] = useState(0);

  const [bodyHeight, setBodyHeight] = useState();
  const [phone, setPhone] = useState("");
  const [sendOTPSuccess, setSendOTPSuccess] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");

  const [phoneError, setPhoneError] = useState("");
  const [firstNameErr, setFirstNameErr] = useState("");
  const [lastNameErr, setLastNameErr] = useState("");
  const [errorMsg, setError] = useState("");
  const [otp, setOtp] = useState("");
  const [mailUpdated, setMailUpdated] = useState("");
  const [showMerge, setShowMerge] = useState(false);
  const [showMail, setShowMail] = useState(false);
  const [numberExists, setNumberExists] = useState(false);
  const [isPhone, setIsPhone] = useState(false);
  const [showPassKeyCreationPopup, setShowPassKeyCreationPopup] =
    useState(false);

  const form = useRef();
  const checkBtn = useRef();

  const NAME = /^[A-Za-z]+$/;

  const allowedRegex = /^(?=.*[0-9])[- +()0-9]+$/;

  const INPUT_STYLE = {
    margin: "10px",
    fontSize: "17px",
    borderRadius: 4,
    border: "1px solid #6F719B",
    color: "#fff",
    width: "56px",
    height: "56px",
    border: "1px solid #9498B5",
    borderRadius: "8px",
  };
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const { loader } = useSelector((state) => state.app);
  const fingerprint = useSelector((state) => state.fingerprint);
  const message_id = useSelector(
    (state) => state.auth.userSignup?.data?.message_id
  );
  const accountMerge = useSelector((state) => state.accountMerge);
  const recaptcha = useSelector((state) => state.recaptcha);
  const [sendOtpError, setSendOtpError] = useState("");
  const [mailUpdatedError, setMailUpdatedError] = useState("");
  const authToken = getUserToken();

  const {
    registerPassKey: { registrationComplete, error },
  } = auth || {};

  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  const signup = (data) => {
    // setSubmitSignup(true);
    if (validatePhone()) {
      const input = ("+1" + data.phone).replace(/[- )(]/g, "");
      dispatch(
        userSignup({
          mobile_number: input,
          refCode: "",
          reCaptcha: recaptcha.data,
          deviceId: fingerprint.data,
        })
      )
        .unwrap()
        .then((response) => {
          setMailUpdatedError("");
          CompleteRegistration();
          setScreenType(2);
          dispatch(getAuth());
          // Web_Signup_completed({
          //   signup_source: "web",
          //   mobile_number: response.user.phone,
          // });
        })
        .catch((error) => {
          setSubmitSignup(false);
          if (error?.error?.code === 5036) {
            setNumberExists(true);
          }
          if (error.error?.code === 5047) {
            setIsPhone(true);
          }
          dispatch(getRecaptcha({ action: "signup" }));
        });
    }
  };

  const handleVerifyOtp = () => {
    if (isValidForm()) {
      const input = ("+1" + phone).replace(/[- )(]/g, "");
      dispatch(
        verifyOtp({ otp, phone: input, message_id, fingerprint, navigate })
      )
        .unwrap()
        .then((response) => {
          CompleteRegistration();
          Web_Signup_completed({
            signup_source: "web",
            mobile_number: input,
            source: screenType,
            utm_source: utm_source || "organic",
          });
          setScreenType(3);
        })
        .catch((error) => {
          if (error?.error?.code === 4013 || error?.error?.code === 9002) {
            console.log(error);
          }
        });
    }
  };
  const fetchUserData = async () => {
    const storedUserData = await getUser();
    const mailUpdated = storedUserData?.user?.email_updated;
    setMailUpdated(mailUpdated);
  };

  useEffect(() => {
    fetchUserData();
    if (authToken) {
      window.history.pushState(null, "", window.location.href);
      window.onpopstate = function () {
        window.history.pushState(null, "", window.location.href);
      };
      if (!mailUpdated && mailUpdated !== "") {
        setScreenType(3);
        return;
      }
    }
  }, [authToken, mailUpdated]);

  const checkPassKeySupport = () => {
    const PublicKeyCredential = window.PublicKeyCredential;
    if (
      PublicKeyCredential &&
      PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable
    ) {
      Promise.all([
        PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable(),
      ])
        .then((results) => {
          if (results.every((r) => r === true)) {
            postMparticleEvent({
              eventName: "Web_passkey_creation_popup_fired",
              eventType: ["EVENT"],
              attributes: {},
            });
            setShowPassKeyCreationPopup(true);
          }
        })
        .catch((e) => {
          console.log(e);
          postMparticleEvent({
            eventName: "Web_passkey_creation_not_supported",
            eventType: ["EVENT"],
            attributes: {},
          });
          setShowPassKeyCreationPopup(false);
        });
    }
  };

  const handleProfile = async (data) => {
    if (validateSignupForm()) {
      dispatch(
        updateProfile({
          first_name: firstName,
          last_name: lastName,
          email: email,
          token: authToken,
        })
      )
        .unwrap()
        .then((response) => {
          Web_Signup_completed({
            signup_source: "web",
            email,
            utm_source: utm_source || "organic",
          });
          const { user_origin_country } = response.user;

          if (user_origin_country === "INDIAN") {
            Add_To_Wishlist({
              email,
            });
            HQUserSignup();
            dispatch(setUserType(user_origin_country));
          }

          CompleteRegistration();
          // dispatch(getAuth());
          setSubmitSignup(false);
          checkPassKeySupport();
          // setShowPassKeyCreationPopup(true);
          // if (isRemittanceSignUp) {
          //   // navigate("/plaid?utm_source=remittance", { replace: true });
          //   navigate(REMITTANCE_NB_HOME_PATH, { replace: true });
          //   return;
          // }
          // navigate("/plaid", { replace: true });
        })
        .catch((error) => {
          if (error?.error?.code !== 5046 || error?.error?.code !== 4002) {
            setMailUpdatedError(error.error?.message);
          }
          if (error?.error?.code === 4002) {
            setMailUpdatedError("");
            setShowMerge(true);
          }
          if (error?.error?.code === 5046) {
            setMailUpdatedError("");
            setShowMail(true);
          }
          if (error?.error?.code === 4013 || error?.error?.code === 9002) {
            console.log(error);
          }
          console.log(error);
        });
    }
  };

  const handleResendOTP = () => {
    const input = ("+1" + phone).replace(/[- )(]/g, "");
    dispatch(
      resendOtp({
        phone: input,
        message_id,
      })
    )
      .unwrap()
      .then((response) => {
        setSendOTPSuccess(true);
      })
      .catch((error) => {
        setSendOTPSuccess(false);
        console.log(error);
      });
  };

  const validateSignupForm = () => {
    try {
      if (!firstName || !lastName || !email) {
        setError("This Field is required");
      } else {
        setError("");
        return true;
      }
      if (auth.validateEmail.error) {
        return false;
      }
    } catch (error) {
      return false;
    }
  };

  const handleOtpChange = (value) => {
    if (NUMBER.test(Number(value))) {
      setOtp(value);
    }
  };

  const handleKey = (e) => {
    if (!e.key.match(allowedRegex)) {
      e.preventDefault();
    }
  };

  const handleChange = (e) => {
    const tempVal = inputFormat(e);
    if (!tempVal) {
      setPhone("");
      setPhoneError("");
      return;
    }
    if (tempVal) {
      if (tempVal.length === 0) {
        setSubmitSignup(true);
      } else {
        setSubmitSignup(false);
      }
      setPhone(tempVal);
      setPhoneError("");
    }
  };

  const validatePhone = () => {
    const formattedPhone = phoneValidation(phone);
    if (formattedPhone) {
      setPhone(formattedPhone);
      setPhoneError("");
      return true;
    } else {
      setPhoneError("Invalid Phone Number");
      return false;
    }
  };

  useEffect(() => {
    if (!phone && !authToken) {
      setSubmitSignup(true);
      setScreenType(1);
    }
    return () => {
      setSendOtpError("");
      setMailUpdatedError("");
      setPhoneError("");
      dispatch(resetUserSignup());
    };
  }, []);

  useEffect(() => {
    if (screentype === 2) setCounter(60);
    return () => {
      dispatch(resetVerifyOtp());
    };
  }, [screentype]);

  useEffect(() => {
    if (screentype === 2) {
      counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
    }
  }, [screentype, counter]);

  const isValidForm = () => {
    if (!otp || otp.length !== 6) {
      return false;
    }
    return true;
  };

  const handleKeyUp = (e) => {
    if (otp.length === 6) {
      e?.target?.blur();
      handleVerifyOtp();
    }
  };

  useEffect(() => {
    if (sendOTPSuccess) {
      setCounter(60);
    }
  }, [sendOTPSuccess]);

  const handleFirstName = (e) => {
    if (!isEmpty(e.target.value)) {
      setError("");
      if (NAME.test(e.target.value)) {
        setFirstName(e.target.value);
        setFirstNameErr("");
      } else {
        setFirstNameErr("Invalid Name Format");
      }
    } else {
      setFirstName("");
      setFirstNameErr("This Field is required");
    }
  };

  const handleLastName = (e) => {
    if (!isEmpty(e.target.value)) {
      if (NAME.test(e.target.value)) {
        setLastName(e.target.value);
        setLastNameErr("");
        setError("");
      } else {
        setLastNameErr("Invalid Name Format");
      }
    } else {
      setLastName("");
      setLastNameErr("This Field is required");
    }
  };

  const handleEmail = (e) => {
    setEmail(e.target.value);
  };

  // useEffect(() => {
  //   dispatch(getRecaptcha({ action: "signup" }));
  // }, [dispatch]);

  const getInitiationSource = () => {
    if (utm_source) {
      return utm_source;
    }
    return getUtmSource();
  };

  useEffect(() => {
    setMount(true);
    if (mount === true) {
      Web_Signup_landed({
        utm_source: getInitiationSource(), //getUtmSource(),
        utm_medium: getUtmMedium(),
        utm_campaign: getUtmCampaign(),
        user_source: null,
        source: screenType,
      });

      interval0.current = setInterval(() => {
        if (watch("email") === "") {
          const userData = JSON.parse(
            sessionStorage.getItem("userData") || "{}"
          );
          if (userData.username) {
            reset({ email: userData.username });
            setEmailReadOnly(true);
          }
        } else {
          clearInterval(interval0.current);
        }
      }, 500);
    }

    return () => {
      clearInterval(interval0.current);
    };
  }, [mount]);

  useLayoutEffect(() => {
    const headerHeight = $(".header").outerHeight();
    const footerHeight = $(".footer").outerHeight();
    setBodyHeight(
      parseFloat($(window).outerHeight() || 0) -
        (parseFloat(headerHeight || 0) + parseFloat(footerHeight || 0))
    );
  }, []);

  const handleAction = () => {
    if (showMerge) {
      dispatch(sendOtpMerge({ email: email, token: authToken }))
        .unwrap()
        .then((response) => {
          setShowMerge(false);
          setSendOtpError("");
          navigate("/verifyDetails", {
            state: { mobileInput: phone, email: email },
          });
          return;
        })
        .catch((error) => {
          setSendOtpError(error?.response?.data?.error?.message);
          console.log(error);
        });
    }
    if (showMail) {
      setShowMail(false);
      return;
    }
    if (numberExists || isPhone) {
      setNumberExists(false);
      setSendOtpError("");
      navigate("/login", { replace: true });
      return;
    }
  };

  const createPassKey = () => {
    if (registrationComplete) {
      continueWithoutPasskey();
      return;
    }
    postMparticleEvent({
      eventName: "create_passkey_clicked",
      eventType: ["EVENT"],
      attributes: {},
    });
    dispatch(registerPassKey({ navigate }));
  };

  useEffect(() => {
    if (registrationComplete) {
      continueWithoutPasskey();
    }
  }, [registrationComplete]);

  const continueWithoutPasskey = () => {
    if (isRemittanceSignUp) {
      // navigate("/plaid?utm_source=remittance", { replace: true });
      navigate(REMITTANCE_NB_HOME_PATH, { replace: true });
      return;
    }
    navigate("/plaid", { replace: true });
  };

  const handleContinue = () => {
    if (showMail) {
      setShowMail(false);
      removeUser().then((response) => {
        removeAllLocalStorageData();
        navigate("/login", { replace: true });
        return;
      });
      dispatch(mergeUsersLogout({ token: authToken }))
        .unwrap()
        .then((res) => {
          navigate("/login", { replace: true });
          return;
        })
        .catch((error) => {
          console.log(error);
        });
    }
    if (numberExists || isPhone) {
      setNumberExists(false);
      setIsPhone(false);
      dispatch(resetUserSignup());
      setPhone("");
      navigate("/signup", { replace: true });
      return;
    }
    setShowMerge(false);
    setSendOtpError("");
  };

  return (
    <>
      <div className="header">
        <div className="container">
          <div className="headTop">
            {/* <a href="/" className="logo">
              <img src={Logo} />
            </a> */}
            {!isRemittanceSignUp && (
              <>
                {" "}
                <div className="topNav">
                  <a
                    href="#"
                    className={
                      screentype === 1
                        ? `navLink signupId active`
                        : screentype === 2
                        ? `navLink progress active`
                        : `navLink signupDone active`
                    }
                  >
                    Get Started
                  </a>
                  <a href="#" className="navLink">
                    Complete Registration
                  </a>
                  {/* <a href="#" className="navLink">
                Offers
              </a> */}
                  <a href="#" className="navLink">
                    Get the App
                  </a>
                </div>
              </>
            )}

            <div className="mobCurrentPage">
              <span className="curntPgNo">1 of 3</span> Account
            </div>
          </div>
        </div>
      </div>
      <div
        className="containtSec"
        style={{ minHeight: `${bodyHeight}px`, position: "relative" }}
      >
        <div className={`mid-container`}>
          <div className="container">
            <div className="acntContntRow">
              <div className="actntCntLeftCol pb0-mob">
                <div className="hedSec">
                  {screentype === 1 && (
                    <>
                      <h2>
                        {isRemittanceSignUp
                          ? `Welcome to Abound, the premier app for NRI’s in the US`
                          : `Shop Our Brands. We’ll Find You Cash Back.`}
                        <br />
                      </h2>
                      <h3>
                        {isRemittanceSignUp
                          ? "Send money to India at the best exchange rates with $0 transfer fees. Also get exclusive rewards, offers on your favorite brands, and automatic cashback on 4,000+ Indian grocery stores!"
                          : "Abound gives you cash back on exclusive deals."}
                      </h3>
                    </>
                  )}
                  {screentype === 2 && (
                    <>
                      <h2>Verify your phone</h2>
                      <h3>
                        We sent a 6 digit code to +1 {phone}.
                        <br />
                        <h3>Please enter it below.</h3>
                      </h3>
                    </>
                  )}
                  {screentype === 3 && (
                    <>
                      <h2>Add Your Info</h2>
                      <br />
                      <h3>
                        Enter your full name and email to complete the signup.
                      </h3>
                    </>
                  )}
                </div>
                <>
                  <form
                    className="frmSec"
                    id="formmm"
                    onSubmit={handleSubmit(signup)}
                    ref={form}
                  >
                    <div id="iPhoneUser">
                      <div className="formGroup">
                        <div className="signupContainer">
                          <div className="signupFields">
                            {screentype === 1 && (
                              <>
                                <div className={`mobileInptContainer`}>
                                  <span className={`countryCode`}>+1</span>
                                  <input
                                    className={`mobileInput ${
                                      errors.phone ? "inputErr" : ""
                                    }`}
                                    id="phone"
                                    value={phone}
                                    placeholder=" Phone Number"
                                    {...register("phone", {
                                      required: true,
                                    })}
                                    onChange={handleChange}
                                    onKeyPress={handleKey}
                                    type="tel"
                                    maxLength={14}
                                  />
                                </div>
                                {auth.userSignup?.error?.message &&
                                  !errors.phone && (
                                    <span className="errMsg">
                                      {auth.userSignup?.error?.message}
                                    </span>
                                  )}
                                <span className={`formControlMessage`}>
                                  {phoneError}
                                </span>
                              </>
                            )}
                            {screentype === 2 && (
                              <>
                                <div
                                  onKeyUp={handleKeyUp}
                                  className={`otpInput`}
                                >
                                  <OtpInput
                                    shouldAutoFocus={true}
                                    numInputs={6}
                                    value={otp}
                                    onChange={handleOtpChange}
                                    inputStyle={`input_style`}
                                    className={`formGroupOtp`}
                                    renderInput={(props) => (
                                      <input
                                        {...props}
                                        disabled={loader}
                                        type="number"
                                        inputMode="numeric"
                                      />
                                    )}
                                  />
                                </div>

                                {auth.verifyOtpService?.error?.error
                                  ?.message && (
                                  <span className="errMsg">
                                    {
                                      auth.verifyOtpService?.error?.error
                                        ?.message
                                    }
                                  </span>
                                )}
                                {auth.resendOtp?.error?.error?.message && (
                                  <span className="errMsg">
                                    {auth.resendOtp?.error?.error?.message}
                                  </span>
                                )}
                              </>
                            )}
                            {/* {!verifyOtpSuccess && (
                      <div className={`invalidOTPtext`}>
              failed
                      </div>
                    )} */}
                          </div>
                        </div>
                        {screentype === 1 && (
                          <>
                            <div className="mobileInptText">
                              Please use your personal mobile number.
                            </div>
                          </>
                        )}
                        {sendOTPSuccess && screentype === 2 && (
                          <div className={`resendOTPtext`}>New Code Sent!</div>
                        )}
                        {screentype === 2 && (
                          <>
                            {counter !== 0 ? (
                              <div className="mobileInptText">{`Resend code in ${counter}s`}</div>
                            ) : (
                              <div className={`resendOtp`}>
                                <a onClick={handleResendOTP}>
                                  {" "}
                                  {"Send Code Again ->"}
                                </a>
                              </div>
                            )}
                          </>
                        )}
                        {screentype === 1 && (
                          <>
                            {loader ? (
                              <AppSkeleton
                                height={84}
                                width="313px"
                                className="btnLoader"
                              />
                            ) : (
                              <div className="actnSec">
                                <button
                                  disabled={isSubmitSignup}
                                  type="submit"
                                  className={
                                    isSubmitSignup
                                      ? `btnPrimary disabled`
                                      : `btnPrimary btnBlock`
                                  }
                                >
                                  Continue
                                </button>
                              </div>
                            )}

                            {/* <div
                              className="signup_tnc"
                              style={{ paddingBottom: " 24px" }}
                            >
                              By hitting Continue below, you agree to our{" "}
                              <a href="/consent" target="_blank">
                                Consent
                              </a>
                              ,{" "}
                              <a href="/terms-conditions" target="_blank">
                                Terms
                              </a>
                              ,{" "}
                              <a href="/privacy" target="_blank">
                                Privacy Policy{" "}
                              </a>
                              & Direct Debit Auth.
                            </div>{" "} */}
                            <div
                              className="signup_tnc"
                              style={{ paddingBottom: " 24px" }}
                            >
                              By clicking Continue below, I agree to the{" "}
                              <a
                                href="/consent"
                                target="_blank"
                                className="link_underLine"
                              >
                                Abound Consent
                              </a>
                              , and{" "}
                              <a
                                href="/terms-conditions"
                                target="_blank"
                                className="link_underLine"
                              >
                                Terms and Conditions
                              </a>
                              , and acknowledge the receipt of the{" "}
                              <a
                                href="/privacy"
                                target="_blank"
                                className="link_underLine"
                              >
                                Privacy Policy
                              </a>
                              .
                            </div>
                          </>
                        )}
                      </div>

                      <div className="formGroup"></div>

                      {/* {message && (
                    <div className="form-group">
                      <div className={successful ? "alert alert-success" : "alert alert-danger"} role="alert">
                        {message}
                      </div>
                    </div>
                  )} */}
                      <input
                        type="check"
                        style={{ display: "none" }}
                        ref={checkBtn}
                      />
                    </div>
                  </form>
                  {screentype === 3 && (
                    <>
                      <div className={`nameContainer`}>
                        <div className={`firstNameContainer`}>
                          <input
                            type="text"
                            className={`frmControl ${
                              errors.firstName ? "inputErr" : ""
                            }`}
                            placeholder="First Name"
                            required="true"
                            onChange={handleFirstName}
                            value={firstName}
                          />
                          <span className="errMsg">{firstNameErr}</span>
                          {!firstName && !firstNameErr && (
                            <span className="errMsg">{errorMsg}</span>
                          )}
                        </div>
                        <div className={`lastNameContainer`}>
                          <input
                            type="text"
                            className={`frmControl ${
                              errors.lastName ? "inputErr" : ""
                            }`}
                            placeholder="Last Name"
                            onChange={handleLastName}
                            value={lastName}
                          />
                          <span className="errMsg">{lastNameErr}</span>
                          {!lastName && !lastNameErr && (
                            <span className="errMsg">{errorMsg}</span>
                          )}
                        </div>
                      </div>
                      <div className="formGroup">
                        <input
                          readOnly={emailReadOnly}
                          type="text"
                          className={`frmControl ${
                            auth.validateEmail.error?.message ? "inputErr" : ""
                          }`}
                          placeholder="Email Address"
                          value={email}
                          onChange={handleEmail}
                          // onBlur={(e) => {
                          //   if (!errors.email) {
                          //     dispatch(validateEmail(e.target.value));
                          //   }
                          // }}
                        />
                        {auth.updateProfileService.error &&
                          !auth.validateEmail.error && (
                            <span className="errMsg">
                              {auth.updateProfileService.error?.error?.message}
                            </span>
                          )}
                        {!email && <span className="errMsg">{errorMsg}</span>}
                        {mailUpdatedError && (
                          <span className="errMsg">{mailUpdatedError}</span>
                        )}
                      </div>

                      {loader ? (
                        <AppSkeleton
                          height={84}
                          width="313px"
                          className="btnLoader"
                        />
                      ) : (
                        <div className="actnSec">
                          <button
                            disabled={isSubmitSignup}
                            className={
                              isSubmitSignup
                                ? `btnPrimary disabled`
                                : `btnPrimary btnBlock`
                            }
                            onClick={handleProfile}
                          >
                            Next
                          </button>
                        </div>
                      )}
                    </>
                  )}
                </>
              </div>
              {showMerge && (
                <CustomPopupBox
                  imgSrc={emailLogo}
                  imgClass="logoImg"
                  heading1={"Email already exist."}
                  headingClass="accountHeader"
                  descrText1={`An account with this email `}
                  descrText2={`${email} already exists.`}
                  descrText3={`Verify your account or create a new one?`}
                  descrClass="descrText"
                  btnTxt1={"Verify & merge accounts"}
                  btnTxt2={"Continue with a different email"}
                  handleAction={() => handleAction()}
                  handleContinue={() => handleContinue()}
                  errorMsg={sendOtpError}
                />
              )}
              {showMail && (
                <CustomPopupBox
                  imgSrc={emailLogo}
                  imgClass="logoImg"
                  heading1={"Email already exist."}
                  headingClass="accountHeader"
                  descrText1={`An account with this email .`}
                  descrText2={`${email} already exists. If you have`}
                  descrText3={`any issue please contact us at support@joinabound.com`}
                  descrClass="descrText"
                  btnTxt1={"Continue with a different email"}
                  btnTxt2={"Already have an account? Login"}
                  handleAction={() => handleAction()}
                  handleContinue={() => handleContinue()}
                />
              )}
              {numberExists && (
                <CustomPopupBox
                  imgSrc={phoneLogo}
                  imgClass="logoImg"
                  heading1={"You already have an account"}
                  headingClass="accountHeader"
                  descrText1={
                    numberExists
                      ? `An account with ${phone}`
                      : `This phone is already registered with an email id. Please use that to 
                        log in or contact us at support@joinabound@queries.com`
                  }
                  descrText2="already exists. Log in or use a new number?"
                  descrClass="descrText"
                  btnTxt1={"Login"}
                  btnTxt2={"Continue with a new phone number"}
                  handleAction={() => handleAction()}
                  handleContinue={() => handleContinue()}
                />
              )}

              {isPhone && (
                <CustomPopupBox
                  imgSrc={phoneLogo}
                  imgClass="logoImg"
                  heading1={"You already have an account"}
                  headingClass="accountHeader"
                  descrText1="This phone is already registered with an email id."
                  descrText2="Please use that to 
                  log in or contact us"
                  descrText3="at support@joinabound@queries.com"
                  descrClass="descrText"
                  btnTxt1={"Login"}
                  btnTxt2={"Continue with a new phone number"}
                  handleAction={() => handleAction()}
                  handleContinue={() => handleContinue()}
                />
              )}
              {showPassKeyCreationPopup && (
                <CustomPopupBox
                  imgSrc={passkey}
                  imgClass="passkeyLogoImg"
                  heading1={"Create a passkey for faster, easier log in"}
                  headingClass="passkeyHeader"
                  descrText1="With passkeys you don’t need to remember complex passwords. Instead, you can use your fingerprints, face, or screen lock to log in."
                  descrText2=""
                  descrText3=""
                  descrClass="passkeyDescr"
                  btnTxt1={
                    !registrationComplete ? "Create Passkey" : "Continue"
                  }
                  handleAction={createPassKey}
                  handleContinue={
                    !registrationComplete ? continueWithoutPasskey : null
                  }
                  customClass={true}
                  errorMsg={error}
                  // successMsg={
                  //   registrationComplete ? "Passkey created successfully" : ""
                  // }
                  isWhiteBg
                />
              )}
              <div>
                <CarouselProvider
                  className="sliderStyle"
                  naturalSlideWidth={288}
                  naturalSlideHeight={376}
                  totalSlides={
                    appConfig.signupSliderItems.filter((item) =>
                      item.source.includes(screenType)
                    ).length
                  }
                  isPlaying={true}
                  lockOnWindowScroll={true}
                  interval={5000}
                >
                  <Slider>
                    {appConfig.signupSliderItems
                      .filter((item) => item.source.includes(screenType))
                      .map((data, index) => {
                        return (
                          <Slide index={index} key={index}>
                            <div className="slideItem">
                              <img src={data.url} />
                            </div>
                          </Slide>
                        );
                      })}
                  </Slider>
                  <ButtonBack className="sliderBtn sliderBtnBack">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15 19l-7-7 7-7"
                      />
                    </svg>
                  </ButtonBack>
                  <ButtonNext className="sliderBtn sliderBtnNext">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </ButtonNext>
                  <DotGroup className="sliderDots" />
                </CarouselProvider>
              </div>
            </div>
          </div>
          <div className="login-option">
            <div className="desktopHide">
              Already have an account?{" "}
              <Link to="/login">
                <span className="login-option-btn">Login</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <AccountFooter />
      {/* {loader && <LoadingSpinner />} */}
    </>
  );
}

export default Signup;
